import React from "react";

const Notification = ({ message }) => <p>{message}</p>;

export default Notification;
